// tslint:disable

import axios, { AxiosResponse } from 'axios';
import * as React from 'react';
import { InputField } from '../../components/fields/input.field';
import { WysiwygField } from '../../components/fields/wysiwyg.field';
import { FormLib } from '../../components/libs/form.lib';
import { ResourceLoader } from '../../components/libs/resource-loader';
import { DefaultSave } from '../../components/libs/updaters/default-save';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { ToggleBoxComponent } from '../../components/structurals/toggle-box.component';
import { Environment } from '../../environment/environment';

export class DefaultMailTemplate extends React.Component<any, any> {
    public state: any = {
        customMenu: null
    };
    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);

    public async saveForm(form: FormLib): Promise<any> {
        this.executor.updateForm(form);
        await this.executor.exec();
    }

    async componentDidMount() {
        try {

            const response: AxiosResponse = await axios.get(`${Environment.get('api.base')}/mail-template/getFields/${this.props.ENTITY_ID}`, {
                withCredentials: true,
            });
            this.setState({customMenu: response.data});

        } catch (err) {
            // console.log(err);
        }
    }

    render() {
        return (
            <ResourceLoader entity="mail-template" entityId={this.props.ENTITY_ID} render={(form: FormLib) => <div>

                <LoaderComponent isLoading$={this.executor.loading$}/>
                <ToggleBoxComponent title="View Mail template" color="green" alwaysOpen={true}>
                    <div className="row">
                        <div className="col-xs-12">


                            <InputField
                                field={form.fields.subject}
                            />
                            <InputField
                                field={form.fields.type}
                                disabled={true}
                            />
                            {this.state.customMenu &&
                            <WysiwygField
                                field={form.fields.body}
                                customMenu={this.state.customMenu}
                            />
                            }

                            <InputField
                                field={form.fields.mailAddress}
                            />
                        </div>
                        <div className="col-xs-12">
                            <button className="btn btn-primary pull-left" onClick={() => this.saveForm(form)}>Save</button>
                        </div>
                    </div>
                </ToggleBoxComponent>
            </div>}/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/default.mail-template.tsx